import { useAccountInfoFetcher } from '@/hooks/global/useAccountInfoFetcher'
import { usePermissionsFetcher } from '@/hooks/global/usePermissionsFetcher'
import { usePremiumFeaturesFetcher } from '@/hooks/global/usePremiumFeaturesFetcher'

export function PermissionsWrapper({ children }: { children: React.ReactNode }) {
  usePermissionsFetcher()
  usePremiumFeaturesFetcher()
  useAccountInfoFetcher()

  return <>{children}</>
}
